import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { CacheFactory } from './CacheFactory'
import { Criteria } from './Criteria'
import { FKType } from './SQLBuilder'

type ReportCriteriaConstructorArgs = ConstructorArgs<() => ReportCriteria>

export class ReportCriteria extends BaseRecord {
    dateType?: string
    filterValue?: string

    constructor(
        data?: Partial<ReportCriteriaConstructorArgs>,
        params?: { criteria?: Criteria; dateType?: string; filterValue?: string }
    ) {
        super(data)
        if (!data) {
            if (!!params) {
                this.id = params?.criteria?.id
                this.criteria = params?.criteria
                this.dateType = params?.dateType
                this.filterValue = params?.filterValue
            }
            return
        }

        this.dateType = data.date_type ?? undefined
        this.filterValue = data.filter_value ?? undefined
    }

    clone(overrides?: Partial<ReportCriteriaConstructorArgs>): ReportCriteria {
        return new ReportCriteria({ ...this.serializeForClone(), ...overrides })
    }

    static initById(id: string): ReportCriteria {
        return (
            (CacheFactory.getInstance().getRecord(Criteria, id) as ReportCriteria) ??
            new ReportCriteria({ id })
        )
    }

    static initByCriteria(
        criteria: Criteria,
        dateType: string,
        filterValue: string
    ): ReportCriteria {
        return new ReportCriteria(undefined, { criteria, dateType, filterValue })
    }

    deserialize(data: any) {
        super.deserialize(data)

        if (data.criteria) this.criteria = BaseRecord.fromSerializer(data.criteria, Criteria)
    }

    jsonObject(): any {
        const dict = super.jsonObject()
        if (this.criteria?.field !== undefined) dict['field'] = this.criteria.field.id
        else dict['criteria'] = this.criteria?.id
        dict['date_type'] = this.dateType ?? ''
        dict['filter_value'] = this.filterValue ?? ''
        return dict
    }

    static fk: FKType = {
        criterias: ['criteria'],
    }

    get recordType(): string {
        return 'criteria'
    }

    static dataType(): DataType {
        return 'criterias' as DataType
    }

    get criteria(): Criteria | undefined {
        return this.getForeignRecord('criteria', Criteria)
    }
    set criteria(criteria: Criteria | undefined) {
        this.setForeignRecord('criteria', criteria)
    }
}
